import { client } from '#shared/apollo-api/business/client';

export default defineNuxtPlugin(() => {
  // Инициализация Apollo Client
  return {
    provide: {
      apollo: client,
    },
  };
});
